import React, {Component} from 'react';
import _ from 'lodash';
import {Steps, Row, Col, Button, Icon, Modal} from 'antd';
import { routeActions } from 'react-router-redux';
const Step = Steps.Step;
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import { actions as meAction } from 'modules/me';
import signInAsync from 'helpers/signInAsync';
import fetchMeAsync from 'helpers/fetchMeAsync';
import enableUserAsync from "helpers/enableUserAsync";
import {init} from 'modules/app';
import base64 from 'base-64';
import { logAsync } from 'helpers/elogAsync';
import './style.css';

const container = connect (
  createSelector(
    (state) => ({
      query: _.get(state, 'router.location.query')
    }),
    (state) => ({
      ...state
    })
  )
)

class Register extends Component {
  state = {
    current: _.get(this.props, 'query.current', 0),
    register: {
      username: '',
      email: '',
      password: '',
      password2: '',
    },
    showPasswordIsChecked: false,
    password2Checked: false,
    usernameChecked: false,
    showNameIsChecked: false,
    c: false,
    emailChecked: false,
    showEmailIsChecked:false,
  }

  componentDidMount() {
    const {dispatch, query} = this.props;
    if (_.get(query, 'current')) {
      const { email, password } = query;
      enableUserAsync({
        email: base64.decode(email)
      })
      .then(() => {
        localStorage.email = base64.decode(email);
        localStorage.password = base64.encode(password);
        fetchMeAsync()
        .then(() => {
          dispatch(meAction.meInit())
        })
      })
    }
  }

  handleUserChange = () => {
    this.setState({
      showNameIsChecked: true,
    });
    if (_.get(this.refs, 'username.value') == '') {
      this.setState({
        usernameChecked: true,
      });
      this.refs.username.focus();
    } else {
      this.setState({
        register: {
          ...this.state.register,
          username: _.get(this.refs, 'username.value')
        },
        usernameChecked: false
      })
    }
  }

  handleEmailChange = () => {


    if (_.get(this.refs, 'email.value') == '') {
      this.setState({
        emailChecked: true,
      });
      this.refs.email.focus();
    } else {
      let email =  _.get(this.refs, 'email.value') + '@umac.mo';
      this.setState({
        register: {
          ...this.state.register,
          email: email
        },
        emailChecked: false,
        showEmailIsChecked: true
      })
     }
  }

  handlePassWordChange = () => {
    this.setState({
      register: {
        ...this.state.register,
        password: _.get(this.refs, 'password.value')
      }
    })
  }

  handlePassWord2Change = () => {
    if (_.get(this.refs, 'password2.value') == '' && _.get(this.refs, 'password.value') == '') {
      this.setState({
        showPasswordIsChecked: false,
      })
    } else {
      this.setState({
        register: {
          ...this.state.register,
          password2: _.get(this.refs, 'password2.value')
        },
        showPasswordIsChecked: true,
      })
      if (_.get(this.refs, 'password2.value') !== _.get(this.refs, 'password.value')) {
        this.setState({
          password2Checked: true
        })
      } else {
        this.setState({
          password2Checked: false
        })
      }
    }
  }

  isOpen = () => {
    const { dispatch } = this.props;
    const { register } = this.state;

    if ( register.username !== '' && register.password !== '' && register.email !== '' && register.password2 !== '') {
      dispatch(meAction.register({
        username: register.username,
        email: register.email,
        password: register.password,
        groupId: "7",
        roleId: "954",
        callbackUrl: `${window.location.origin}/#/register?current=2&email=${base64.encode(register.email)}&password=${base64.encode(register.password)}`
      }))
      .then(() => {
        const {register_email} = localStorage;
        logAsync({
          type: "sPOP-register",
          data: {
            username: register.username,
            email: register.email,
            password: register.password,
            user: register_email
          }
        })
        this.setState({
          current: 1
        })
      })
    } else {
      Modal.error({
        title: 'Error',
        content: '请重新检查您所提交的信息',
        okText: 'OK'
      });
    }

  }

  returnHome = () => {
    const {dispatch} = this.props;
    dispatch(routeActions.push({
      pathname: '/home'
    }))
  }

  goEmail = () => {
    window.open("http://webmail.umac.mo/");
  }



  step1 = () => {
    return (
      <div>
        <div>
          <Row className="margin-bottom-md">
            <Col span="3" offset={6}>
              <div className="row-title">用戶名稱</div>
            </Col>
            <Col span="8">
              <input
                type="text"
                className="form-control"
                ref="username"
                onBlur={this.handleUserChange} />
            </Col>
            <Col span='4'>
              {this.state.usernameChecked &&
                <div className="check-error-text">用户名不能為空</div>
              }
              {!this.state.usernameChecked && this.state.showNameIsChecked &&
                <div className="check-success-icon"><Icon type="check-circle" /></div>
              }
            </Col>
          </Row>
          <Row className="margin-bottom-md">
            <Col span="3" offset={6}>
              <div className="row-title">電郵地址</div>
            </Col>
            <Col span="6">
              <input
                type="text"
                className="form-control"
                ref="email"
                onChange = { e=>{ this.setState({
                                    register: {
                                      ...this.state.register,
                                      email: e.target.value,
                                    }
                                  })
                                }
                            }
                onBlur={this.handleEmailChange}

                 />
            </Col>
            <Col span='2'>
              <div style={{ lineHeight: '39px', fontSize: '15px' }}>@umac.mo</div>
            </Col>
            <Col span='4'>
              {this.state.emailChecked &&
                <div className="check-error-text">邮箱号不能为空</div>
              }
              {!this.state.emailChecked && this.state.showEmailIsChecked &&
                <div className="check-success-icon"><Icon type="check-circle" /></div>
              }
            </Col>
          </Row>
          <Row className="margin-bottom-md">
            <Col span="3" offset={6}>
              <div className="row-title">密碼</div>
            </Col>
            <Col span="8">
              <input
                type="password"
                className="form-control"
                ref="password"
                onBlur={this.handlePassWordChange} />
            </Col>
          </Row>
          <Row className="margin-bottom-md">
            <Col span="3" offset={6}>
              <div className="row-title">確認密碼</div>
            </Col>
            <Col span="8">
              <input
                type="password"
                className="form-control"
                ref="password2"
                onBlur={this.handlePassWord2Change} />
            </Col>
            <Col span="4">
            {this.state.password !== '' &&
              <div>
                {this.state.password2Checked &&
                  <div className="check-error-text">兩次輸入密碼不一致</div>
                }
                {!this.state.password2Checked && this.state.showPasswordIsChecked &&
                  <div className="check-success-icon"><Icon type="check-circle" /></div>
                }
              </div>
            }
            </Col>
          </Row>
          <div className="text-center is-open"><Button type="primary" onClick={this.isOpen}>立即開通</Button></div>
        </div>
      </div>
    )
  }

  step2 = () => {
    return (
      <div className="text-center">
        <div className="certification-title">
          <Icon type="mail" />
          <div>我們已向閣下{this.state.register.email}郵箱發送了一封認證郵件，請前往收信，完成認證</div>
        </div>
        <div className="go-email">
          <Button type="primary" onClick={this.goEmail}>前往郵箱完成認證</Button>
        </div>
        <div className="certification-fail">
          <div className="title"><Icon type="question" />沒有收到郵件？</div>
          <div className="content">
            <div>1.查看郵箱的垃圾箱或廣告箱，認證郵件可能被誤判為垃圾郵件。</div>
            <div>2.如果超過5分鐘仍未收到驗證郵件，請點擊<Button>重新發送</Button></div>
          </div>
        </div>
      </div>
    )
  }

  step3 = () => {
    return (
      <div className="open-success text-center">
        <div className="title">
          <Icon type="check-circle" />
          <div>郵箱認證成功，閣下可在平台中進行以下操作：</div>
        </div>
        <div className="content">
          <div>1.收藏資訊</div>
          <div>2.在[收藏夾]中下載數據<span>（下載數量為50條/天，每天00：00重置）</span></div>
        </div>
        <div className="go-email"><Button type="primary" onClick={this.returnHome}>返回首頁</Button></div>
      </div>
    )
  }

  renderContent = (step) => {
    switch(step) {
      case 0:
        return this.step1();
        break;
      case 1:
        return this.step2();
        break;
      case 2:
        return this.step3();
        break;
    }
  }

  render() {
    return (
      <div className="margin-left-md padding-md background-color">
        <div className="register-title padding-bottom-sm">
          <div className="title-left"></div>
          <div className="margin-left-md">開通帳號</div>
        </div>
        <div className="margin-top-md">
          <Steps current={parseInt(this.state.current)}>
            <Step title="提交資料"/>
            <Step title="郵箱認證"/>
            <Step title="成功開通"/>
          </Steps>
          <div className="margin-top-md">
            {this.renderContent(parseInt(this.state.current))}
          </div>
        </div>

      </div>
    )
  }
}
export default container(Register)



/** WEBPACK FOOTER **
 ** ./src/app/modules/sidebar/components/Register.js
 **/